<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chaptitle" id="ch1"><a id="page_1"></a>I.</h2>
<h2 class="chaptitle-1a">LAW IN THE HEARTLAND<a id="page_2"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Chapter01.vue?85ef08b6